import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Card, CardQuery, AuthService, MemberQuery, CardService } from '@fgb/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'fgb-card-select',
  templateUrl: './card-select.component.html',
  styleUrls: ['./card-select.component.scss'],
})
export class CardSelectComponent implements OnInit {
  cards$: Observable<Card[]>;
  showPopup: boolean;
  currentMemberId: string;

  currentMemberCard: Card | undefined;

  name$: Observable<string>;

  @ViewChild('selectedMemberElement') selectedMemberElement: ElementRef;
  @ViewChild('seatSelection') seatSelectionElement: ElementRef;

  constructor(
    private cardQuery: CardQuery,
    private cardService: CardService,
    private authService: AuthService,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit() {
    this.currentMemberId = this.memberQuery.getUserContext().memberId;
    this.cardService
      .fetchCards()
      .toPromise()
      .then(() => {
        this.cards$ = this.cardQuery.selectCards().pipe(
          tap((cards) => {
            this.currentMemberCard = cards.find((c) => c.MemberId == this.currentMemberId);
          }),
          map((cards) => {
            return (cards = cards
              .sort((a, b) => parseInt(a.Seat) - parseInt(b.Seat))
              .sort((a, b) => parseInt(a.Row) - parseInt(b.Row))
              .sort((a, b) => parseInt(a.Area) - parseInt(b.Area))
              .sort((a) => (a.MemberId == this.currentMemberId ? -1 : 0)));
          })
        );
      });
  }

  loginWithCard(memberId: string) {
    this.authService.switchUser(memberId).toPromise();
  }

  @HostListener('document:click', ['$event'])
  outsideComponentClickHandler(e: MouseEvent) {
    if (
      !this.selectedMemberElement.nativeElement.contains(e.target) &&
      !this.seatSelectionElement.nativeElement.contains(e.target)
    ) {
      this.showPopup = false;
    }
  }
}
